/* hismile V34 MX — comportamento da PDP. Zero dependências. */
(function () {
  'use strict';

  // A tag <script> é emitida por cada seção. Só o primeiro boot conta.
  if (window.__hsPdpBooted) return;
  window.__hsPdpBooted = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal ao entrar no viewport ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.hs-rv');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('hs-rv--in'); });
      return;
    }
    // O escalonamento é feito por transition-delay (--hs-delay) no CSS.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('hs-rv--in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Galeria: thumbs <-> scroll-snap ---------- */
  function initGallery(root) {
    var slides = root.querySelector('[data-hs-slides]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-thumb]'));
    if (!slides || !thumbs.length) return;

    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      // pausa qualquer vídeo que não seja o slide ativo
      root.querySelectorAll('video').forEach(function (v, k) {
        var slide = v.closest('[data-hs-slide]');
        if (!slide) return;
        var idx = Array.prototype.indexOf.call(slides.children, slide);
        if (idx !== i && !v.paused) v.pause();
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        slides.scrollTo({ left: slides.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' });
        mark(i);
      });
    });

    var tick;
    slides.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        mark(Math.round(slides.scrollLeft / slides.clientWidth));
      }, 80);
    }, { passive: true });

    mark(0);
  }

  /* ---------- Barra fixa de compra (mobile) ----------
     Mostra quando o sentinela do FIM da buybox já passou para cima.
     Esconde outra vez quando a garantia entra no ecrã: ali já há CTA. */
  function initSticky() {
    var bar = document.querySelector('[data-hs-stick]');
    var sentinel = document.querySelector('[data-hs-stick-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    var pastBuybox = false;
    var atEnd = false;
    function sync() { bar.classList.toggle('hs-stick--on', pastBuybox && !atEnd); }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        pastBuybox = en.boundingClientRect.top < 0 && !en.isIntersecting;
        sync();
      });
    }, { threshold: 0 }).observe(sentinel);

    var closer = document.querySelector('[data-hs-stick-stop]');
    if (closer) {
      new IntersectionObserver(function (entries) {
        atEnd = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(closer);
    }

    var go = bar.querySelector('[data-hs-stick-go]');
    var target = document.getElementById('hs-comprar');
    if (go && target) {
      go.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  /* ---------- Acordeão: fecha os irmãos ---------- */
  function initExclusive() {
    document.querySelectorAll('[data-hs-exclusive]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('details'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Carrossel de depoimentos da buybox ---------- */
  function initRevCarousel(root) {
    var track = root.querySelector('[data-hs-revtrack]');
    var dots = root.querySelector('[data-hs-revdots]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var buttons = [];
    if (dots) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hs-bbrev__dot';
        b.setAttribute('aria-label', 'Reseña ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
        buttons.push(b);
      });
    }
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function mark(i) {
      buttons.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: track.clientWidth * n, behavior: reduced ? 'auto' : 'smooth' });
      mark(n);
    }
    var prev = root.querySelector('[data-hs-revprev]');
    var next = root.querySelector('[data-hs-revnext]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(current()); }, 80);
    }, { passive: true });
    mark(0);

    // autoplay: pausa ao interagir e quando sai do ecrã
    var secs = parseInt(root.getAttribute('data-hs-autoplay') || '0', 10);
    if (!secs || reduced) return;
    var timer = null, paused = false;
    function tick() {
      if (paused) return;
      var i = current();
      go(i >= slides.length - 1 ? 0 : i + 1);
    }
    function start() { stop(); timer = setInterval(tick, secs * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ['pointerdown', 'focusin', 'mouseenter'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = true; stop(); });
    });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting && !paused) start(); else stop();
      }, { threshold: 0.3 }).observe(root);
    } else { start(); }
  }

  /* ---------- Carrossel de vídeos (prova visual) ---------- */
  function initVCarousel(root) {
    var track = root.querySelector('[data-hs-vtrack]');
    var dots = root.querySelector('[data-hs-vdots]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var buttons = [];
    if (dots) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hs-vcar__dot';
        b.setAttribute('aria-label', 'Video ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
        buttons.push(b);
      });
    }
    function current() { return Math.round(track.scrollLeft / (track.clientWidth * 0.74)); }
    function mark(i) {
      buttons.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[n];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      mark(n);
    }
    var prev = root.querySelector('[data-hs-vprev]');
    var next = root.querySelector('[data-hs-vnext]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var best = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; best = i; }
        });
        mark(best);
      }, 80);
    }, { passive: true });
    autoplayVideos(track);
    mark(0);
    autoplay(root, track, slides, go);
  }

  /* ---------- Modal do vídeo, com som ----------
     Na grelha os vídeos correm mudos e em ciclo, que é o que o browser
     deixa. Quem quiser ouvir clica: abre em grande, com som e controlos,
     e a partir do segundo em que estava. */
  function initVideoModal() {
    var vids = document.querySelectorAll('[data-hs-vcar] video');
    if (!vids.length) return;

    var modal, player, closeBtn;

    function build() {
      modal = document.createElement('div');
      modal.className = 'hs-vmodal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Video');
      modal.hidden = true;
      modal.innerHTML =
        '<div class="hs-vmodal__box">' +
          '<video class="hs-vmodal__v" playsinline controls></video>' +
          '<button type="button" class="hs-vmodal__x" aria-label="Cerrar">&times;</button>' +
        '</div>';
      document.body.appendChild(modal);
      player = modal.querySelector('video');
      closeBtn = modal.querySelector('.hs-vmodal__x');
      closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }

    function open(src, poster, at) {
      if (!modal) build();
      player.src = src;
      if (poster) player.poster = poster;
      player.muted = false;
      player.volume = 1;
      player.currentTime = at || 0;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { modal.classList.add('hs-vmodal--on'); });
      var p = player.play();
      if (p && p.catch) p.catch(function () { /* o utilizador carrega no play */ });
      closeBtn.focus();
    }

    function close() {
      modal.classList.remove('hs-vmodal--on');
      player.pause();
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; player.removeAttribute('src'); }, 200);
    }

    vids.forEach(function (v) {
      v.classList.add('hs-vclick');
      v.setAttribute('role', 'button');
      v.setAttribute('tabindex', '0');
      v.setAttribute('aria-label', 'Ver el video con sonido');
      function fire(e) {
        e.preventDefault();
        open(v.currentSrc || v.src, v.getAttribute('poster'), v.currentTime);
      }
      v.addEventListener('click', fire);
      v.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') fire(e);
      });
    });
  }

  /* ---------- Acordeão que também fecha com animação ----------
     <details> anima a abrir (grid-template-rows) mas fecha a seco: o
     browser tira o conteúdo do fluxo no mesmo frame. Seguramos o `open`
     até a altura chegar a zero. */
  function initDetailsAnim() {
    if (reduced) return;
    document.querySelectorAll('.hs-faq__list details').forEach(function (d) {
      var body = d.querySelector('.hs-qa__a');
      if (!body) return;
      var closing = false;

      var EASE = 'cubic-bezier(.22,.61,.36,1)';

      // abertura: o <details> já abriu, medimos a altura natural e subimos
      // de zero até lá. Sem isto o painel aparece de repente.
      d.addEventListener('toggle', function () {
        if (!d.open || closing) return;
        var alvo = body.scrollHeight;
        var pb = getComputedStyle(body).paddingBottom;
        body.style.overflow = 'hidden';
        body.style.height = '0px';
        body.style.paddingBottom = '0px';
        body.style.opacity = '0';
        requestAnimationFrame(function () {
          body.style.transition = 'height .28s ' + EASE +
            ', padding-bottom .28s ' + EASE + ', opacity .22s ease';
          body.style.height = alvo + 'px';
          body.style.paddingBottom = pb;
          body.style.opacity = '1';
        });
        setTimeout(function () { if (d.open) body.removeAttribute('style'); }, 300);
      });

      d.addEventListener('click', function (e) {
        var sum = e.target.closest('summary');
        if (!sum || !d.open || closing) return;
        e.preventDefault();
        closing = true;
        // o padding tem de entrar na animação: só a altura deixava um
        // salto de 18px no último frame, que se lê como corte
        body.style.height = body.clientHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'height .26s ' + EASE +
            ', padding-bottom .26s ' + EASE + ', opacity .18s ease';
          body.style.overflow = 'hidden';
          body.style.opacity = '0';
          body.style.height = '0px';
          body.style.paddingBottom = '0px';
        });
        setTimeout(function () {
          d.open = false;
          closing = false;
          body.removeAttribute('style');
        }, 260);
      });
    });
  }

  /* ---------- Arranque automático dos vídeos ----------
     `autoplay` sozinho não basta: o browser bloqueia fora do ecrã e, sem
     controlos, ficava sem forma de arrancar. Isto dá play ao entrar na
     vista, pausa ao sair, e mostra um botão de reserva se for recusado. */
  function autoplayVideos(scope) {
    var vids = Array.prototype.slice.call((scope || document).querySelectorAll('video[autoplay]'));
    if (!vids.length) return;

    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;

      function fallback() {
        if (v.parentElement.querySelector('.hs-vplay')) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hs-vplay';
        b.setAttribute('aria-label', 'Reproducir video');
        b.addEventListener('click', function () {
          v.play().then(function () { b.remove(); }).catch(function () { v.controls = true; b.remove(); });
        });
        v.parentElement.appendChild(b);
      }

      function tryPlay() {
        var p = v.play();
        if (p && p.catch) p.catch(fallback);
      }

      if (reduced) { fallback(); return; }

      // num carrossel o track clipa os slides de fora: observa-se a seção,
      // não cada vídeo, senão só o slide à vista chega a arrancar
      var carousel = v.closest('[data-hs-vcar]');
      var target = carousel || v;
      var thr = carousel ? 0.05 : 0.35;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) tryPlay(); else v.pause();
          });
        }, { threshold: thr }).observe(target);
      } else {
        tryPlay();
      }
    });
  }

  /* ---------- Objeções em separadores ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-tab]'));
    if (!tabs.length) return;
    var panels = root.querySelectorAll('[data-hs-panel]');
    var inline = root.querySelectorAll('[data-hs-panel-inline]');

    function show(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      inline.forEach(function (p, k) { p.hidden = k !== i; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        // no telemóvel a resposta abre por baixo: clicar na aberta fecha
        var aberta = t.getAttribute('aria-selected') === 'true';
        var estreito = window.matchMedia('(max-width: 899px)').matches;
        if (aberta && estreito) {
          t.setAttribute('aria-selected', 'false');
          inline.forEach(function (p) { p.hidden = true; });
          return;
        }
        show(i);
      });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1
              : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length;
        tabs[n].focus(); show(n);
      });
    });
  }

  /* ---------- Carrossel genérico com dots ---------- */
  function initDotCarousel(root, trackSel, dotsSel, dotClass) {
    var track = root.querySelector(trackSel);
    var dots = root.querySelector(dotsSel);
    if (!track || !dots) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    var buttons = cards.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = dotClass;
      b.setAttribute('aria-label', 'Ver ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft,
                         behavior: reduced ? 'auto' : 'smooth' });
      });
      dots.appendChild(b);
      return b;
    });
    function mark() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      buttons.forEach(function (b, k) { b.setAttribute('aria-current', k === best ? 'true' : 'false'); });
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(mark, 80);
    }, { passive: true });
    mark();
    autoplay(root, track, cards, function (i) {
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft,
                       behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Autoplay partilhado pelos carrosséis ----------
     Avança sozinho, para quando o dedo toca, e só corre com o carrossel
     à vista: um carrossel a rodar fora do ecrã só gasta bateria. */
  function autoplay(root, track, items, goTo) {
    var secs = parseInt(root.getAttribute('data-hs-autoplay') || '0', 10);
    if (!secs || reduced || items.length < 2) return;

    var timer = null, paused = false;

    function nearest() {
      var best = 0, min = Infinity;
      items.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function tick() {
      if (paused) return;
      var i = nearest();
      goTo(i >= items.length - 1 ? 0 : i + 1);
    }
    function start() { stop(); timer = setInterval(tick, secs * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    ['pointerdown', 'focusin', 'mouseenter'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = true; stop(); });
    });
    root.addEventListener('mouseleave', function () { paused = false; start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting && !paused) start(); else stop();
      }, { threshold: 0.25 }).observe(root);
    } else { start(); }
  }

  function boot() {
    initReveal();
    document.querySelectorAll('[data-hs-rvc]').forEach(function (r) {
      initDotCarousel(r, '[data-hs-rvc-track]', '[data-hs-rvc-dots]', 'hs-rvc__dot');
    });
    document.querySelectorAll('[data-hs-stp]').forEach(function (r) {
      initDotCarousel(r, '[data-hs-stp-track]', '[data-hs-stp-dots]', 'hs-stp__dot');
    });
    document.querySelectorAll('[data-hs-tabs]').forEach(initTabs);
    autoplayVideos(document);
    document.querySelectorAll('[data-hs-vcar]').forEach(initVCarousel);
    document.querySelectorAll('[data-hs-revcar]').forEach(initRevCarousel);
    initVideoModal();
    initDetailsAnim();
    document.querySelectorAll('[data-hs-gallery]').forEach(initGallery);
    initSticky();
    initExclusive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
